import React, { useState, useEffect } from "react"
import styled from "styled-components"
import SearchBar from "./searchBar"
import { HomeDrawer } from "./homeDrawer"
import { IconContainer, WebView, MobileView } from "../styles/common"
import { Menu } from "styled-icons/material/Menu"
import {
  SearchSmall,
  Close,
} from "@omnichannel/ace-b2b-elements"
import { APP_ID } from "../helpers/constants"
import CartAccountBox from "./cartAccountBox"
import { LocationOn } from "styled-icons/material"
import { ActiveBranch } from "../context/activeBranch"
import { navigate, useStaticQuery, graphql } from "gatsby"
import Ace from "../images/ace-logo.png"
import CategoryRow from "./categoryRow"
import { LocationPin } from "styled-icons/entypo"
import { isAuthenticated } from "../utils/utils"

const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;
  background-image: linear-gradient(to right, #474747, #333333);
  @media (min-width: 768px) {
    padding: .2rem 0 .4rem 0;
  }
  @media (min-width: 961px) {
    padding: .2rem 1rem .4rem  1rem;
  }
  @media (min-width: 1441px) {
    padding: .2rem 0 .4rem 0;
  }
`
const HeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  margin: auto;
  max-width: 140rem;
  align-items: center;
  justify-content: space-between;
`

const Location = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const TopRow = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  @media (min-width: 768px) {
    justify-content: space-between;
  }
`

const SearchRow = styled.div`
  width: auto;
  flex: 3;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  @media (min-width: 768px) {
    flex: 4;
    justify-content: center;
  }
`

const DrawerSpacer = styled.div`
  padding: 0 0.2rem 0 1.2rem;
  @media (min-width: 768px) {
    padding: 0 1rem 0 3rem;
    display: none;
  }
`

const Spacing = styled.div`
  padding: 0 1rem;
`

const SearchCartAndAcountAdjuster = styled.div`
  @media (min-width: 768px) {
    /* transform: translateY(.4rem); */
  }
  @media (min-width: 1024px) {
    transform: translateY(1.2rem);
  }
`

const LogoImage = styled.img`
  height: 4rem;
  max-height: 100%;
  cursor: pointer;
  @media (min-width: 768px) {
    padding: 0 0.2rem;
    height: 5.6rem;
  }
`

const LocationIcon = styled(LocationOn)`
  width: 2.2rem;
  height: 2.2rem;
  color: #fff;
  cursor: pointer;
`

const LogoContainer = styled.div`
  max-width: 38rem;
  padding: 1.4rem 0.6rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media (min-width: 768px) {
    padding: 2rem 0.8rem 2rem 0.8rem;
    max-width: 38rem;
  }
`

const TextM1 = styled.div`
  color: #fff;
  margin: auto 0.2rem;
  font-size: 1.4rem;
  font-weight: 500;
  cursor: pointer;
`

const InlinedLink = styled.div`
  cursor: pointer;
`

const RightActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`

const LeftAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const IconButton = styled.div`
  cursor: pointer;
`

const CloseButton = styled.div`
  align-self: flex-start;
  padding: 1rem 2rem;
`

const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 3;
  @media (min-width: 768px) {
    flex: 4;
  }
`

const CurrentBranchBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  display: flex;
  padding: 1rem 1rem 0.8rem 1.45rem;
  background-color: #000;
`

const Header = ({ cartPop, hideCartPop, location, performAuthCheck = true }) => {
  const [open, setOpen] = useState(false)
  const [showSearch, setShowSearch] = useState(false)

  const category = useStaticQuery(graphql`
    query HomeCategories {
      estore {
        categories {
          _id
          name
          children {
            _id
            name
          }
        }
        getHomepageBrands(limit: 10, isFeatured: true) {
          _id
          name
          image
          order
        }
      }
    }
  `)

  useEffect(() => {
    if (performAuthCheck && !isAuthenticated()) {
      navigate("/login")
    }
    let appId = localStorage.getItem("omniAppId")
    if (!appId) {
      localStorage.setItem("omniAppId", APP_ID)
    }
  }, [])

  return (
    <>
      <HeaderContainer>
        <HeaderContent>
          <LeftAction>
            <DrawerSpacer>
              <IconContainer onClick={() => setOpen(!open)} cursor={"pointer"}>
                <Menu width={"24"} height={"24"} color={"#fff"} />
              </IconContainer>
            </DrawerSpacer>
            <LogoContainer>
              <LogoImage
                src={Ace}
                onClick={() => {
                  navigate("/")
                }}
              />
            </LogoContainer>
          </LeftAction>
          {!showSearch ? (
            <ActionContainer>
              <TopRow>
                <WebView>
                  <ActiveBranch.Consumer>
                    {({ activeBranch }) => {
                      return (
                        <Location>
                          <LocationIcon onClick={() => navigate("/stores")} />
                          <div>
                            <InlinedLink onClick={() => navigate("/stores")}>
                              <TextM1>
                                {activeBranch
                                  ? `You are shopping at 
                                  ${activeBranch ? activeBranch.name.replace("ACE Hardware","") : ""}
                                    `
                                  : "Select a branch to shop"}
                              </TextM1>
                            </InlinedLink>
                          </div>
                        </Location>
                      )
                    }}
                  </ActiveBranch.Consumer>
                </WebView>
                <RightActions>
                  <WebView>
                    <SearchCartAndAcountAdjuster>
                      <IconButton
                        onClick={() => {
                          setShowSearch(true)
                        }}
                      >
                        <SearchSmall width={24} height={24} color={"#FFF"} />
                      </IconButton>
                    </SearchCartAndAcountAdjuster>
                  </WebView>
                  <MobileView>
                    <IconButton
                      onClick={() => {
                        const path = `/searchquery?path=${location.pathname ? location.pathname : ""}${window.location.search && encodeURIComponent(window.location.search)}`
                        navigate(path, { state: { searchKey: location.state && location.state.searchKey } })
                      }}
                      style={{ transform: "translate(.3rem, .1rem)" }}
                    >
                      <SearchSmall width={30} height={30} color={"#FFF"} />
                    </IconButton>
                  </MobileView>
                  <SearchCartAndAcountAdjuster>
                    <Spacing>
                      <CartAccountBox
                        cartPop={cartPop}
                        hideCartPop={hideCartPop}
                      />
                    </Spacing>
                  </SearchCartAndAcountAdjuster>
                </RightActions>
              </TopRow>
              <WebView>
                <CategoryRow
                  categories={category.estore.categories}
                  brands={category.estore.getHomepageBrands}
                />
              </WebView>
            </ActionContainer>
          ) : (
              <>
                <SearchRow>
                  <SearchBar autoFocus={true} />
                </SearchRow>
                <CloseButton>
                  <IconButton
                    onClick={() => {
                      setShowSearch(false)
                    }}
                  >
                    <Close width={30} height={30} color={"#FFF"} />
                  </IconButton>
                </CloseButton>
              </>
            )}
        </HeaderContent>
      </HeaderContainer>
      {location.pathname === "/" && (
        <MobileView>
          <CurrentBranchBox>
            <LocationPin width={"20"} height={"20"} color={"#fff"} />
            <ActiveBranch.Consumer>
              {({ activeBranch }) => {
                return (
                  <div
                    style={{ width: "100%", userSelect: "none" }}
                    onClick={() => {
                      navigate("/stores")
                    }}
                  >
                    <TextM1
                      style={{ fontSize: "1.4rem", paddingLeft: ".6rem" }}
                    >
                      You are shopping at{" "}
                      {activeBranch
                        ? activeBranch?.name.replace("ACE Hardware", "")
                        : "Select a branch"}
                    </TextM1>
                  </div>
                )
              }}
            </ActiveBranch.Consumer>
          </CurrentBranchBox>
        </MobileView>
      )}
      <HomeDrawer
        open={open}
        onClose={() => setOpen(!open)}
        categories={category.estore.categories}
        brands={category.estore.getHomepageBrands}
      />
    </>
  )
}

export default Header
